// Cache DOM selectors on load to avoid repetitive queries
document.addEventListener("DOMContentLoaded", function() {
  const productIdInput = document.getElementById("product-id");
  const recommendationsContainer = document.getElementById("product-recommendations-product-page");
  const recommendationsTitle = document.querySelector(".recTitle");
  
  // Store common DOM elements and selectors in a cached object
  window.DOMCache = {
    miniCart: document.getElementById("mini-cart"),
    miniCartToggle: document.querySelector('[data-action="toggle-mini-cart"]'),
    cartCountSelectors: [
      '.cart-count-bubble span',
      '.header__cart-count',
      '.site-header__cart-indicator',
      '.cart-link__bubble-num',
      '[data-cart-count]',
      '.cart-count',
      '.cart-item-count'
    ],
    bubbleSelectors: [
      '.cart-link__bubble',
      '.site-header__cart-indicator',
      '.cart-count-bubble'
    ]
  };

  if (!productIdInput || !recommendationsContainer) {
    console.error("Product ID input or recommendations container not found.");
    return;
  }

  // Initialize recommendations cache
  if (!window.recommendationsCache) {
    window.recommendationsCache = {};
  }

  fetchRecommendations(productIdInput.value, recommendationsContainer, recommendationsTitle);
});

function fetchRecommendations(productId, container, titleElement) {
  // Check cache first before making a network request
  if (window.recommendationsCache[productId]) {
    console.log("Using cached recommendations for product:", productId);
    processRecommendations(window.recommendationsCache[productId], container, titleElement);
    return;
  }

  // Always show loading state or previous content while waiting for new data
  // This ensures something is displayed even on first load
  if (titleElement) titleElement.style.display = "block";
  
  // Add timeout to prevent hanging requests
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 5000); // 5-second timeout

  fetch(`https://bale.co.nz/golfhq/cross-sell/proxy.php?action=recommendations&product_id=${productId}`, {
    signal: controller.signal
  })
    .then(response => {
      clearTimeout(timeoutId);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return response.json();
    })
    .then(data => {
      // Cache the response
      window.recommendationsCache[productId] = data;
      processRecommendations(data, container, titleElement);
    })
    .catch(error => {
      clearTimeout(timeoutId);
      if (error.name === 'AbortError') {
        console.error("Request timed out when fetching recommendations");
      } else {
        console.error("Error fetching related items:", error);
      }
      displayRelatedItems([], container, titleElement);
    });
}

function processRecommendations(data, container, titleElement) {
  if (!data || !Array.isArray(data.recommended_products) || data.recommended_products.length === 0) {
    console.error("Invalid or empty response from proxy.php", data);
    displayRelatedItems([], container, titleElement);
    return;
  }

  // Use map once to transform data efficiently
  const recommendations = data.recommended_products.map(item => ({
    id: item.product.id.replace('gid://shopify/Product/', ''),
    title: item.product.title,
    handle: item.product.handle,
    images: item.product.images,
    variants: item.product.variants,
    defaultVariantId: item.product.defaultVariantId,
    source: item.source
  }));

  const finalRecommendations = selectTopRecommendations(recommendations);
  displayRelatedItems(finalRecommendations, container, titleElement);
}

function selectTopRecommendations(recommendations) {
  // Prioritize related products and collection items
  const priorityItems = recommendations.filter(item =>
    item.source && (item.source.startsWith('related_product') || item.source.startsWith('collection_'))
  );

  // Fill up to 3 items if needed with random selections
  const finalItems = [...priorityItems];
  
  // If we already have 3 or more priority items, just return the first 3
  if (finalItems.length >= 3) return finalItems.slice(0, 3);
  
  // Otherwise, efficiently select random items to fill the remaining slots
  const remainingItems = recommendations.filter(item => !priorityItems.includes(item));
  const neededItems = 3 - finalItems.length;
  
  // More efficient way to select random items without splicing in a loop
  if (remainingItems.length > 0) {
    // Shuffle a portion of the array if there are many items
    const shuffledRemaining = remainingItems.sort(() => 0.5 - Math.random()).slice(0, neededItems);
    finalItems.push(...shuffledRemaining);
  }

  return finalItems.slice(0, 3);
}

function displayRelatedItems(products, container, titleElement) {
  if (!products || products.length === 0) {
    container.innerHTML = "";
    if (titleElement) titleElement.style.display = "none";
    return;
  }

  // Create all elements in a document fragment to minimize DOM operations
  const fragment = document.createDocumentFragment();
  
  // Use requestAnimationFrame to batch DOM updates
  requestAnimationFrame(() => {
    products.forEach(product => {
      if (product) fragment.appendChild(createProductCard(product));
    });

    container.innerHTML = "";
    container.appendChild(fragment);
    if (titleElement) titleElement.style.display = "block";
  });
}

// Preload image placeholder to avoid layout shifts
const placeholderImage = new Image();
placeholderImage.src = "//via.placeholder.com/300x300?text=No+Image";
const errorPlaceholder = new Image();
errorPlaceholder.src = "//via.placeholder.com/300x300?text=Image+Failed";

function createProductCard(product) {
  const card = document.createElement("div");
  card.classList.add("product-item", "product-item--vertical");

  // Image section
  const imageLink = document.createElement("a");
  imageLink.href = `/products/${product.handle}`;
  imageLink.classList.add("product-item__image-wrapper");

  const imageContainer = document.createElement("div");
  imageContainer.classList.add("aspect-ratio", "aspect-ratio--square");

  const image = document.createElement("img");
  let imgSrc = placeholderImage.src; // Use preloaded placeholder
  let imgAlt = "No image available";

  if (product.images && Array.isArray(product.images.edges) && product.images.edges.length > 0 && product.images.edges[0].node && product.images.edges[0].node.src) {
    imgSrc = product.images.edges[0].node.src;
    imgAlt = product.title;
  } else {
    console.warn(`No valid image source found for product: ${product.title} (ID: ${product.id})`);
  }

  image.alt = imgAlt;
  image.classList.add("product-item__primary-image");
  image.loading = "lazy";
  
  // Set width and height attributes to prevent layout shifts
  image.width = 300;
  image.height = 300;
  
  // Set src last to trigger load event
  image.src = imgSrc;

  // Add an event listener to handle image loading errors
  image.onerror = function() {
    console.error(`Error loading image for product: ${product.title} (ID: ${product.id}) from URL: ${this.src}`);
    this.src = errorPlaceholder.src; // Use preloaded error placeholder
  };

  imageContainer.appendChild(image);
  imageLink.appendChild(imageContainer);

  // Info section
  const infoContainer = document.createElement("div");
  infoContainer.classList.add("product-item__info-inner");

  const titleLink = document.createElement("a");
  titleLink.href = `/products/${product.handle}`;
  titleLink.classList.add("product-item__title", "text--strong", "link");
  titleLink.textContent = product.title;

  infoContainer.appendChild(titleLink);

  // Add to cart form
  const form = createAddToCartForm(product);

  // Assemble card
  card.appendChild(imageLink);
  card.appendChild(infoContainer);
  card.appendChild(form);

  return card;
}

function createAddToCartForm(product) {
  const form = document.createElement("form");
  form.id = "add-to-cart-form";
  form.className = "add-to-cart-form";
  form.method = "post";
  form.action = "/cart/add";

  // Get variant ID - more efficient string replacement
  let variantId = product.defaultVariantId || (product.variants?.edges[0]?.node?.id || "");
  if (variantId.startsWith("gid://shopify/ProductVariant/")) {
    variantId = variantId.substring(27); // Faster than regex replace
  }

  // Create form elements all at once
  form.innerHTML = `
    <input type="hidden" name="id" value="${variantId}">
    <input type="hidden" name="quantity" value="1">
    <button type="submit" class="button shop-now-button">Add to Cart</button>
  `;

  return form;
}

// Form utility - more efficient implementation
window.Form = {
  serialize: function(form) {
    return Object.fromEntries(new FormData(form));
  }
};

// Update cart counter function - optimized
function updateCartCounters(cartData) {
  const { cartCountSelectors, bubbleSelectors } = window.DOMCache;
  const count = cartData.item_count;
  
  // Use requestAnimationFrame to batch DOM updates
  requestAnimationFrame(() => {
    // Update counter numbers
    cartCountSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(counter => {
        counter.textContent = count;
      });
    });

    // Only update bubbles if items exist (boolean check is faster)
    if (count > 0) {
      bubbleSelectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(bubble => {
          bubble.classList.add('cart-bubble--visible');
          bubble.style.display = 'block';
        });
      });
    }
  });
}

// Cart action handler using event delegation
document.addEventListener("submit", function(event) {
  if (!event.target.matches("#add-to-cart-form")) return;

  event.preventDefault();
  const form = event.target;
  const addButton = form.querySelector('button[type="submit"]');

  if (!form.reportValidity()) return;

  addButton.setAttribute("disabled", "disabled");
  document.dispatchEvent(new CustomEvent("theme:loading:start"));

  const formData = Form.serialize(form);

  // Use Promise.all for parallel requests where possible
  fetch(`${window.routes.cartAddUrl}.js`, {
    body: JSON.stringify(formData),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
    }
  })
  .then(response => {
    document.dispatchEvent(new CustomEvent("theme:loading:end"));

    if (response.ok) {
      return response.json().then(cartData => {
        addButton.removeAttribute("disabled");

        // Update cart counter with the received data
        updateCartCounters(cartData);

        // Dispatch event after updating UI
        document.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: { id: formData.id },
              button: addButton,
              quantity: parseInt(formData.quantity)
            }
          })
        );
        
        // Track event asynchronously to not block main thread
        if (window.gtag) {
          setTimeout(() => {
            gtag('event', 'add_to_cart_recommendation', {
              item_id: formData.id,
              quantity: parseInt(formData.quantity),
            });
          }, 0);
        }
        
        return fetch("/cart?section_id=mini-cart");
      });
    } else {
      return response.json().then(data => {
        alert(data.description || "Error adding to cart");
        addButton.removeAttribute("disabled");
        throw new Error(response.status === 422 ? "Validation error" : "Server error");
      });
    }
  })
  .then(response => response?.ok ? response.text() : null)
  .then(html => {
    if (!html) return;

    const { miniCart, miniCartToggle } = window.DOMCache;
    if (!miniCart) {
      console.error("Mini-cart element not found.");
      return;
    }

    // Parse HTML once and efficiently
    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(html, "text/html");
    const newMiniCart = parsedDoc.getElementById("mini-cart");
    
    if (!newMiniCart) {
      console.error("Could not find mini-cart in fetched HTML.");
      return;
    }

    // Use requestAnimationFrame for DOM updates
    requestAnimationFrame(() => {
      miniCart.innerHTML = newMiniCart.innerHTML;

      if (miniCartToggle) {
        miniCartToggle.click();
      } else {
        console.log("Mini-cart toggle not found.");
      }
    });

    // Fetch cart data in parallel rather than sequentially
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        updateCartCounters(cartData);
      });
  })
  .catch(error => {
    if (error.message !== "Validation error" && error.message !== "Server error") {
      console.error("Error adding product to cart:", error);
      alert("An unexpected error occurred. Please try again.");
      addButton.removeAttribute("disabled");
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  });
});